// extracted by mini-css-extract-plugin
export default {"invalidFileLabel":"app-assets-javascripts-screens-imports-newImports__invalidFileLabel--xxKtx"};